<template>
    <EditingDialog 
        :context="context + 'Splits'"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col cols="5">
                    <BaseEditPageDropdown 
                        :context="context +'Splits'"
                        field="Rights"
                        :items="rightsDropdownItems" 
                        :label="$t('lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_RIGHTS')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-rights'"
                    />
                </v-col>
                <v-col cols="5">
                    <BaseEditPageDropdown 
                        :context="context +'Splits'"
                        field="ApplyTo"
                        :items="applyToDropdownItems" 
                        :label="$t('lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_APPLY_TO')"
                        :selection="true"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-apply-to'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="5">
                    <BaseEditPageTextField 
                        :context="context +'Splits'"
                        field="Base"
                        :label="$t('lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_BASE')"
                        :withMargin="false"
                        rules="percentDecimal|required"
                        :alvqa="alvqa + '-textfield-base'"
                    />
                </v-col>
                <v-col cols="5">
                    <BaseEditPageTextField 
                        :context="context +'Splits'"
                        field="Split"
                        :label="$t('lang_GENERAL_CAPTION_SPLIT')"
                        :withMargin="false"
                        rules="percentDecimal|required"
                        :alvqa="alvqa + '-textfield-split'"
                    />
                </v-col>
            </v-row>
            <BaseRegions 
                :context="context +'SplitsEditingDialog'"
                includeLabel="lang_PUBLISHING_WORKS_EXPORT_INCLUDE_TERRITORY"
                excludeLabel="lang_PUBLISHING_WORKS_EXPORT_EXCLUDE_TERRITORY"
                :includeItems="includeItems"
                :excludeItems="excludeItems"
                includeCols="5"
                excludeCols="5"
                :clearable="false"
                :alvqa="alvqa"
            />
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseRegions from '@/components/_base/BaseRegions'

import { DropdownContractsPublishingApplyTo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "PublishingContractsSplitsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseRegions
    },
    data() {
        return {
            context: "PublishingContract",
            alvqa: "contracts-publishing-edit-form-splits-panel-editing-dialog"
        }
    },
    computed: {
        rightsDropdownItems() { 
            let alvqa = this.alvqa + "-dropdown-rights-"
            let rightsArr
            let rights = this.$store.getters.getPublishingContractTypeOfRights

            if(rights !== undefined) {
                // PT_TODO: for non-GEMA Home Societies, hide entries 1,2,5,6
                rightsArr = JSON.parse(JSON.stringify(rights))
                rightsArr.forEach(right => {
                    right['alvqa'] = alvqa + right.value.toLowerCase()
                });
            }
            return rightsArr
        },
        applyToDropdownItems() { 
            let alvqa = this.alvqa + "-dropdown-apply-to-"
            let applyToArr
            let applyTo = DropdownContractsPublishingApplyTo 

            if(applyTo !== undefined) {
                applyToArr = JSON.parse(JSON.stringify(applyTo))
                applyToArr.forEach(element => {
                    element['alvqa'] = alvqa + element.value
                });
            }
            return applyToArr
        },
        includeItems() { 
            let storeIncludes = this.$alvPlugin.getListOfTranslatedCountries()
            storeIncludes.unshift({text: this.$t('lang_CAPTION_REGION_WORLD'), value: 'WORLD'})
            return storeIncludes
        },
        excludeItems() { return this.$alvPlugin.getListOfTranslatedCountries() },
    }
}
</script>